import { useQuery } from '@tanstack/react-query';
import { getBankOperationComments } from 'config/requests/bankOperations';

export const useBankOperationComments = (id: number | undefined, enabled = true) => {
  const { data: comments = [], isLoading } = useQuery({
    queryKey: ['bank_operations/comments', id],
    queryFn: () => getBankOperationComments(id!),
    enabled: Boolean(id) && enabled,
  });

  return { comments, isLoading };
};
